export var ConnectionNames;
(function (ConnectionNames) {
    ConnectionNames["sports"] = "SportsbookConnection";
    ConnectionNames["betslip"] = "BetSlipConnection";
    ConnectionNames["realityCheck"] = "RealityCheckConnection";
    ConnectionNames["player"] = "PlayerDataConnection";
    ConnectionNames["login"] = "LoginConnection";
    ConnectionNames["betsReporting"] = "BetsReportingConnection";
    ConnectionNames["casino"] = "CasinoConnection";
    ConnectionNames["captor"] = "CaptorConnection";
    ConnectionNames["search"] = "SearchConnection";
    ConnectionNames["openBets"] = "OpenBetsConnection";
    ConnectionNames["casinoPlayerActivity"] = "CasinoPlayerActivityAPIConnection";
    ConnectionNames["tournaments"] = "TournamentsConnection";
    ConnectionNames["captcha"] = "CaptchaConnection";
    ConnectionNames["yourBet"] = "YourBetConnection";
})(ConnectionNames || (ConnectionNames = {}));
//# sourceMappingURL=ConnectionNames.js.map